import React from "react";
import "./BarPlot.css";

export default function BarPlot({ barPlot }) {
  return (
    <div className="barPlot">
      <div className="barPlot__label">{barPlot.Attribute}</div>
      <div
        className="barPlot__container plot barPlot__point"
        style={{
          width: barPlot.Product_point + "px",
        }}
      >
        <div
          className="plot barPlot__clientAverage"
          style={{
            width: barPlot.Client_average + "px",
          }}
        ></div>
      </div>
    </div>
  );
}
